/* BioGood Labs – GlyNAC landing page behaviour. No dependencies. */
(function () {
  'use strict';
  if (window.__bglpInit) return; window.__bglpInit = true;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    var slides = $('.bglp-slides', root); if (!slides) return;
    var thumbs = $$('.bglp-thumb', root);
    var list = $('.bglp-thumbs__list', root);
    var idx = 0;
    function mark() { thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === idx ? 'true' : 'false'); }); }
    function go(i) {
      var n = slides.children.length; if (!n) return;
      idx = (i + n) % n;
      slides.scrollTo({ left: slides.children[idx].offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      mark();
      var t = thumbs[idx]; if (t && list) list.scrollTo({ left: t.offsetLeft - list.offsetLeft - (list.clientWidth - t.clientWidth) / 2, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var p = $('.bglp-thumbs__btn--prev', root), nx = $('.bglp-thumbs__btn--next', root);
    if (p) p.addEventListener('click', function () { go(idx - 1); });
    if (nx) nx.addEventListener('click', function () { go(idx + 1); });
    var timer;
    slides.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var w = slides.clientWidth; if (!w) return;
        var k = Math.round(slides.scrollLeft / w);
        if (k !== idx) { idx = k; mark(); }
      }, 80);
    });
  }

  /* ---------- ship date ---------- */
  function ordinal(d) { var s = ['th', 'st', 'nd', 'rd'], v = d % 100; return d + (s[(v - 20) % 10] || s[v] || s[0]); }
  function initShipDate(root) {
    $$('[data-bglp-ship-days]', root).forEach(function (el) {
      var days = parseInt(el.getAttribute('data-bglp-ship-days'), 10) || 1;
      var d = new Date();
      while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
      el.textContent = d.toLocaleDateString('en-US', { month: 'long' }) + ' ' + ordinal(d.getDate());
    });
  }

  /* ---------- bundles + subscription ---------- */
  function initForm(root) {
    var form = $('.bglp-form', root); if (!form) return;
    var qty = $('input[name="quantity"]', form);
    var plan = $('input[name="selling_plan"]', form);
    var sub = $('.bglp-sub-card input', form);
    var bars = $$('.bglp-bar', form);
    function sync() {
      bars.forEach(function (b) {
        var r = $('input', b);
        b.classList.toggle('is-selected', r.checked);
        if (r.checked && qty) qty.value = r.getAttribute('data-qty') || '1';
      });
      if (sub) {
        sub.closest('.bglp-sub-card').classList.toggle('is-checked', sub.checked);
        if (plan) plan.disabled = !sub.checked;
      }
    }
    form.addEventListener('change', sync); sync();
  }

  /* ---------- countdown ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initTimer(root) {
    $$('[data-bglp-timer]', root).forEach(function (el) {
      var prefix = el.getAttribute('data-prefix') || '';
      var end = el.getAttribute('data-end');
      function tick() {
        var now = new Date(), target;
        if (end) { target = new Date(end); } else { target = new Date(now); target.setHours(24, 0, 0, 0); }
        var s = Math.max(0, Math.floor((target - now) / 1000));
        if (end && s === 0) { el.style.visibility = 'hidden'; return; }
        el.textContent = prefix + pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- videos ---------- */
  function initVideos(root) {
    $$('.bglp-video', root).forEach(function (w) {
      var v = $('video', w), b = $('.bglp-video__play', w); if (!v || !b) return;
      b.addEventListener('click', function () {
        if (v.paused) {
          $$('.bglp-video video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.bglp-video').classList.remove('is-playing'); } });
          v.muted = false; v.play(); w.classList.add('is-playing');
        } else { v.pause(); w.classList.remove('is-playing'); }
      });
      v.addEventListener('click', function () { v.pause(); w.classList.remove('is-playing'); });
    });
  }

  /* ---------- upsell ---------- */
  function initUpsell(root) {
    $$('.bglp-upsell__btn[data-variant]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-variant'), quantity: 1 }] })
        }).then(function (r) { return r.json(); }).then(function () {
          btn.querySelector('span').textContent = btn.getAttribute('data-added') || 'Added';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }).catch(function () { btn.disabled = false; });
      });
    });
  }

  /* ---------- ingredients modal ---------- */
  function initIngredients(root) {
    var modal = $('.bglp-modal', root); if (!modal) return;
    var slides = $$('.bglp-modal__slide', modal), cur = 0;
    function show(i) { cur = (i + slides.length) % slides.length; slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); }); }
    function open(i) { show(i); modal.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    $$('.bglp-ingr__card', root).forEach(function (c, k) { c.addEventListener('click', function () { open(k); }); });
    $$('.bglp-modal__close', modal).forEach(function (b) { b.addEventListener('click', close); });
    var pv = $('[data-prev]', modal), nx = $('[data-next]', modal);
    if (pv) pv.addEventListener('click', function () { show(cur - 1); });
    if (nx) nx.addEventListener('click', function () { show(cur + 1); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  }

  /* ---------- testimonials ---------- */
  function initTestimonials(root) {
    var track = $('.bglp-test__track', root); if (!track) return;
    function step(dir) { var c = track.children[0]; if (!c) return; track.scrollBy({ left: dir * (c.getBoundingClientRect().width + 19.5), behavior: 'smooth' }); }
    var p = $('.bglp-test__nav [data-prev]', root), n = $('.bglp-test__nav [data-next]', root);
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  }

  function init(root) {
    initGallery(root); initShipDate(root); initForm(root); initTimer(root);
    initVideos(root); initUpsell(root); initIngredients(root); initTestimonials(root);
  }
  function boot() { $$('.bglp[data-bglp]').forEach(function (s) { if (!s.__bglp) { s.__bglp = true; init(s); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
